import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
export const Emoji = async t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="inline-block scale-125">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
Emoji.displayName = "Emoji";
export default Emoji;